export const tr = {
    'common-price-editor-description-phrases':
        'Belirteceğiniz bin gösterim başına teklif tüm sözcük grupları için kullanılacaktır',
    'common-price-editor-description-retargetings':
        'Belirteceğiniz tıklama başına teklif tüm gösterim koşulları için kullanılacaktır',
    'common-price-editor-description-users-profile':
        'Belirteceğiniz bin gösterim başına teklif tüm gösterim koşulları için kullanılacaktır',
    'common-price-editor-title': 'Ortak teklif',
    'common-price-editor-title-phrases': 'Sözcük grupları için ortak teklif',
    'common-price-editor-title-retargetings': 'Yeniden pazarlama ve hedef kitle seçimi için ortak teklif',
    'common-price-editor-title-users-profile': 'Kullanıcı profilleri için ortak teklif',
    'selected-phrases': {
        one: '{count} sözcük grubu seçildi',
        some: '{count} sözcük grubu seçildi',
        many: '{count} sözcük grubu seçildi',
        none: '{count} sözcük grubu seçildi'
    },
    'selected-retargetings': {
        one: '{count} koşul seçildi',
        some: '{count} koşul seçildi',
        many: '{count} koşul seçildi',
        none: '{count} koşul seçildi'
    },
    'set-cpc-price': 'Ortak tıklama fiyatını belirt',
    'set-cpm-price': 'Bin gösterim başına ortak teklif belirt',
    'set-price': 'Ortak teklif belirt',
    'single-rate-max-price': 'Ortak teklif en fazla {maxValue} {currency} olabilir',
    'single-rate-min-price': 'Ortak teklif en az {minValue} {currency} olabilir'
};
